import React, { memo, useEffect } from 'react'
import { ProgressPane } from '@pff-consumer/feature-fantasy/web/lib/progress-pane/progress-pane.web'
import { CurrentProgressState } from '@pff-consumer/schema'
import { useAnalytics } from '@pff-consumer/analytics'
import { useRouter } from 'next/router'
import { Button } from '../common/button/button'
import { useStyles } from './create-account-success.styles'
import { Routes } from '../../utils/routes'
import { useRedirectTo } from '../common/hooks/useRedirectTo'

export const CreateAccountSuccess = memo(() => {
  const router = useRouter()
  const styles = useStyles()
  const { sendAnalyticsEvent } = useAnalytics()

  const onRouterReady = (redirectToParam: string) => {
    router.push({ query: { success: true, redirect_to: redirectToParam } }, undefined, { shallow: true })
  }

  const { redirectTo } = useRedirectTo({ router, onReady: onRouterReady })

  useEffect(() => {
    sendAnalyticsEvent('Account Created', {
      // TODO Need to pass accountMethod appropriately when social sign-in are implemented
      accountMethod: 'Email',
      subscriptionType: 'Free',
      source: 'Fantasy League Sync',
    })
  }, [])

  return (
    <div className={styles.createAccountContainer}>
      <ProgressPane
        state={CurrentProgressState.SUCCESS}
        header='Success! Account Created'
        message='Please sign in to continue with your free account.'
      >
        <Button
          className={styles.button}
          text='Sign in'
          role='button'
          variant='Primary'
          type='button'
          onClick={() => {
            // We do not use router so it invokes the login check on merlin side
            window.location.href = `${Routes.Login}?redirect_to=${redirectTo}`
          }}
        />
      </ProgressPane>
    </div>
  )
})
